// extracted by mini-css-extract-plugin
module.exports = {"welcome":"Welcome_welcome__3qCfl","big":"Welcome_big__3aXd-","reds":"Welcome_reds__2XR2u","blues":"Welcome_blues__2bl9-"};